import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import SignupForm from "../components/authPartials/SignupForm";
import ExpressCheckoutForm from "../components/shopPartials/ExpressCheckoutForm";
import OrderCheckout from "../components/shopPartials/OrderCheckout";
import { useCart } from "../components/contexts/CartContext";
import { useGeneral } from "../components/contexts/GeneralContext";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
import { useEffect } from "react";

const ExpressCheckoutPage = () => {
  const { cart, fetchCart, loading } = useCart(); // ✅ Use global cart context
  const { discountCoupons } = useGeneral();
  useEffect(() => {
    fetchCart();
  }, []);

  return (
    <>
      <PageWrapper loading={loading} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        {loading && <FullScreenLoading />}
        <BodyWrapper loading={loading} className="">
          <ExpressCheckoutForm />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default ExpressCheckoutPage;
